import { render, staticRenderFns } from "./LoopColoredAvatar.vue?vue&type=template&id=74a4a07a&scoped=true"
import script from "./LoopColoredAvatar.vue?vue&type=script&lang=js"
export * from "./LoopColoredAvatar.vue?vue&type=script&lang=js"
import style0 from "./LoopColoredAvatar.vue?vue&type=style&index=0&id=74a4a07a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a4a07a",
  null
  
)

export default component.exports